import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetIsBoard, GetIsBoardResponse, GetIsCap, GetIsCapResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetIsBoardResponse, GetIsBoardResponse>) => response?.data?.isBoard;

const getError = (response?: SWRResponse<GetIsBoardResponse, GetIsBoardResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetIsBoardResponse, GetIsBoardResponse>) => ({
    isBoard: response?.data?.isBoard
});

export const useBoardStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }

        return () => {
            return new GetIsBoard({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useBoardStatus;
